<div class="modal_dialog order-details-modal-enhanced">
  <div class="modal_header">
    <h2>{{ "OrderDetails" | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="order-details-layout">
      <!-- Left Section: Product Image Gallery -->
      <div class="left-section">
        <div class="product-image-section">
          
          <!-- Status Display/Edit -->
          <div class="status-section">
            <ng-container *ngIf="data.data.status != orderStatus.FACTORY_ACCEPTED && data.data.status != orderStatus.RETURN_ACCEPTED">
              <ng-container *ngIf="isStatusEditable && permissions.isEdit; else viewStatus">
                <select
                  class="status-select-modal"
                  [value]="data.data.status"
                  (change)="onStatusChangeNative($event, data.data._id)">
                  <ng-container *ngIf="data.data.status == orderStatus.PRODUCT_RECEIVED_QC && !data.data.qcAction">
                    <option *ngIf="data.data.status != orderStatus.ACCEPTED && data.data.status != orderStatus.ORDER_NOT_ACCEPTED && data.data.status != orderStatus.READY_TO_PICK" [value]="data.data.status" selected>
                      {{ getValueByKey(getStatusValue(data.data)) | translate }}
                    </option>
                  </ng-container>
                  <ng-container *ngIf="data.data.status != orderStatus.PRODUCT_RECEIVED_QC">
                    <option *ngIf="data.data.status != orderStatus.ACCEPTED && data.data.status != orderStatus.ORDER_NOT_ACCEPTED && data.data.status != orderStatus.READY_TO_PICK" [value]="data.data.status" selected>
                      {{ getValueByKey(getStatusValue(data.data)) | translate }}
                    </option>
                  </ng-container>
                  <option [value]="orderStatus.RETURN_APPROVED_FULL_REFUND" *ngIf="data.data.status == orderStatus.PRODUCT_RECEIVED_QC && data.data.qcAction == orderStatus.RETURN_APPROVED_FULL_REFUND">
                    {{ 'RETURN_APPROVED_FULL_REFUND' | translate }}
                  </option>
                  <option [value]="orderStatus.RETURN_APPROVED_PARTIAL_REFUND" *ngIf="data.data.status == orderStatus.PRODUCT_RECEIVED_QC && data.data.qcAction == orderStatus.RETURN_APPROVED_PARTIAL_REFUND">
                    {{ 'RETURN_APPROVED_PARTIAL_REFUND' | translate }}
                  </option>
                  <option [value]="orderStatus.RETURN_REJECTED_USER_DAMAGE" *ngIf="data.data.status == orderStatus.PRODUCT_RECEIVED_QC && data.data.qcAction == orderStatus.RETURN_REJECTED_USER_DAMAGE">
                    {{ 'RETURN_REJECTED_USER_DAMAGE' | translate }}
                  </option>
                  <option [value]="orderStatus.RETURN_REJECTED_FRAUD" *ngIf="data.data.status == orderStatus.PRODUCT_RECEIVED_QC && data.data.qcAction == orderStatus.RETURN_REJECTED_FRAUD">
                    {{ 'RETURN_REJECTED_FRAUD' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.ACCEPTED"
                    *ngIf="
                      data.data.status === orderStatus.PENDING ||
                      data.data.status === orderStatus.ACCEPTED
                    ">
                    {{ 'Accepted' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.CANCEL_BY_ADMIN"
                    *ngIf="
                      data.data.status === orderStatus.PENDING ||
                      data.data.status === orderStatus.CANCEL_BY_ADMIN
                    ">
                    {{ 'Rejected' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.READY_TO_PICK"
                    *ngIf="
                      data.data.status === orderStatus.READY_TO_PICK ||
                      data.data.status === orderStatus.ACCEPTED
                    ">
                    {{ 'READY_TO_PICK' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.ORDER_ACCEPTED_BY_DRIVER"
                    *ngIf="
                      data.data.status === orderStatus.ASSIGNED_TO_TEAM ||
                      data.data.status === orderStatus.ASSIGNED_TO_DRIVER_BY_ADMIN
                    ">
                    {{ 'OrderAcceptedByDriver' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.REACHED_PICKUP_LOCATION"
                    *ngIf="
                      data.data.status === orderStatus.ORDER_ACCEPTED_BY_DRIVER
                    ">
                    {{ 'ReachedPickUpLocation' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.ORDER_PICKED_UP"
                    *ngIf="
                      data.data.status === orderStatus.REACHED_PICKUP_LOCATION
                    ">
                    {{ 'OrderPickedUp' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.ORDER_PICKED_UP"
                    *ngIf="data.data.status === orderStatus.READY_TO_PICK && 
                      data.data?.assignedDriver?.driverId?.name">
                    {{ 'PickedByDriver' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.ON_THE_WAY"
                    *ngIf="data.data.status === orderStatus.ORDER_PICKED_UP">
                    {{ 'OnTheWay' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.DELIVERED"
                    *ngIf="data.data.status === orderStatus.ON_THE_WAY">
                    {{ 'Delivered' | translate }}
                  </option>
                  <option
                    [value]="orderStatus.ORDER_NOT_ACCEPTED"
                    *ngIf="data.data?.status === orderStatus.ORDER_NOT_ACCEPTED">
                    {{ 'OrderNotAccepted' | translate }}
                  </option>
                </select>
              </ng-container>
              <ng-template #viewStatus>
                <div class="order-badge" [ngClass]="'status-' + data.data.status">
                  {{ getStatusName(data.data.status) | translate }}
                </div>
              </ng-template>
            </ng-container>
            <div class="order-badge" *ngIf="data.data.status == orderStatus.FACTORY_ACCEPTED || data.data.status == orderStatus.RETURN_ACCEPTED" [ngClass]="'status-' + data.data.status">
              {{ getStatusName(data.data.status) | translate }}
            </div>
          </div>
          <!-- Main Image Display -->
          <div class="product-image-container">
            <img [src]="selectedImage || data.data.product?.image || data.data.productVariant?.image?.[0] || 'assets/images/product-placeholder.png'" 
                 [alt]="data.data.product?.productName"
                 class="product-image">
            <div class="image-navigation" *ngIf="getProductImages().length > 1">
              <button class="nav-btn prev-btn" (click)="previousImage()" [disabled]="currentImageIndex === 0">
                <i class="fa fa-chevron-left"></i>
              </button>
              <button class="nav-btn next-btn" (click)="nextImage()" [disabled]="currentImageIndex === getProductImages().length - 1">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
          
          <!-- Image Thumbnails -->
          <div class="image-thumbnails" *ngIf="getProductImages().length > 1">
            <div class="thumbnail-item" 
                 *ngFor="let img of getProductImages(); let i = index"
                 [class.active]="i === currentImageIndex"
                 (click)="selectImage(i)">
              <img [src]="img" [alt]="'Image ' + (i + 1)">
            </div>
          </div>
        </div>

        <!-- Download Invoice Button -->
        <div class="action-section" *ngIf="orderStatusForInvoice.includes(data.data.status)">
          <button type="button" class="btnn btn_download" (click)="downloadInvoice()">
            <i aria-hidden="true" class="fa fa-download"></i>
            {{ "DownloadInvoice" | translate }}
          </button>
        </div>
      </div>

      <!-- Right Section: Order Information -->
      <div class="right-section">
        <!-- Order Header -->
        <div class="order-header">
          <h2 class="order-title">{{ data.data.product?.productName }}</h2>
          <div class="order-meta">
            <span class="order-number">#{{ data.data.orderNo }}</span>
            <span class="shipment-id" *ngIf="data.data.subOrderNo">| {{ 'Shipment' | translate }}: #{{ data.data.subOrderNo }}</span>
          </div>
        </div>

        <!-- Tabs Section -->
        <mat-tab-group class="order-tabs" animationDuration="300ms">
          <!-- Specifications Tab -->
          <mat-tab [label]="'Specifications' | translate">
            <div class="tab-content">
              <!-- Basic Product Info -->
              <div class="specs-grid">
                <div class="spec-item">
                  <i class="fa fa-cube spec-icon"></i>
                  <div class="spec-info">
                    <span class="spec-label">{{ 'Product' | translate }}</span>
                    <span class="spec-value">{{ data.data.product?.productName }}</span>
                  </div>
                </div>

                <div class="spec-item">
                  <i class="fa fa-cubes spec-icon"></i>
                  <div class="spec-info">
                    <span class="spec-label">{{ 'ProductQuantity' | translate }}</span>
                    <span class="spec-value">{{ data.data.quantity }}</span>
                  </div>
                </div>

                <div class="spec-item">
                  <i class="fa fa-tags spec-icon"></i>
                  <div class="spec-info">
                    <span class="spec-label">{{ 'Category' | translate }}</span>
                    <span class="spec-value">{{ data.data.category?.name || '---' }}</span>
                  </div>
                </div>

                <div class="spec-item">
                  <i class="fa fa-bookmark spec-icon"></i>
                  <div class="spec-info">
                    <span class="spec-label">{{ 'Brand' | translate }}</span>
                    <span class="spec-value">{{ data.data.brand?.name || '---' }}</span>
                  </div>
                </div>

                <div class="spec-item">
                  <i class="fa fa-truck spec-icon"></i>
                  <div class="spec-info">
                    <span class="spec-label">{{ 'DeliveryType' | translate }}</span>
                    <span class="spec-value">{{ data.data.deliveryType === 1 ? 'Express' : 'Normal' }}</span>
                  </div>
                </div>

                <div class="spec-item">
                  <i class="fa fa-credit-card spec-icon"></i>
                  <div class="spec-info">
                    <span class="spec-label">{{ 'PaymentMethod' | translate }}</span>
                    <span class="spec-value">{{ getPaymentMethod() }}</span>
                  </div>
                </div>
              </div>

              <!-- Vendor Details -->
              <div class="vendor-section" *ngIf="data.data.vendor">
                <h3 class="section-title">{{ 'VendorDetails' | translate }}</h3>
                <div class="vendor-info-card">
                  <div class="vendor-avatar">
                    <img [src]="data.data.vendor?.image || 'assets/images/user-placeholder.png'" 
                         [alt]="data.data.vendor?.name">
                  </div>
                  <div class="vendor-details">
                    <div class="vendor-detail-row">
                      <span class="vendor-label">{{ 'VendorName' | translate }}:</span>
                      <span class="vendor-value">{{ data.data.vendor?.name || '---' }}</span>
                    </div>
                    <div class="vendor-detail-row">
                      <span class="vendor-label">{{ 'StoreName' | translate }}:</span>
                      <span class="vendor-value">{{ data.data.vendor?.storeName || '---' }}</span>
                    </div>
                    <div class="vendor-detail-row">
                      <span class="vendor-label">{{ 'VendorType' | translate }}:</span>
                      <span class="vendor-value">{{ getVendorType(data.data.vendor?.vendorType) }}</span>
                    </div>
                    <div class="vendor-detail-row">
                      <span class="vendor-label">{{ 'PhoneNumber' | translate }}:</span>
                      <span class="vendor-value">{{ data.data.vendor?.dialCode }} {{ data.data.vendor?.phoneNo }}</span>
                    </div>
                    <div class="vendor-detail-row">
                      <span class="vendor-label">{{ 'Email' | translate }}:</span>
                      <span class="vendor-value">{{ data.data.vendor?.email || '---' }}</span>
                    </div>
                    <div class="vendor-detail-row">
                      <span class="vendor-label">{{ 'Address' | translate }}:</span>
                      <span class="vendor-value">{{ data.data.vendor?.address || '---' }}</span>
                    </div>
                  </div>
                  <div class="vendor-cover-image-wrapper" *ngIf="data.data.vendor?.coverImage">
                    <label class="cover-image-label">{{ 'CoverImage' | translate }}</label>
                    <div class="vendor-cover-image">
                      <img [src]="data.data.vendor.coverImage" 
                           [alt]="data.data.vendor?.storeName + ' cover'">
                    </div>
                  </div>
                </div>
              </div>

              <!-- Selected Variant -->
              <div class="product-specifications-section" *ngIf="(data.data.productVariant?.attributes?.length || 0) > 0">
                <h3 class="section-title">{{ 'SelectedVariant' | translate }}</h3>
                <div class="specifications-list">
                  <div class="specification-item" *ngFor="let attr of data.data.productVariant?.attributes || []">
                    <div class="specification-header">
                      <i class="fa fa-check-circle spec-check-icon"></i>
                      <span class="specification-title">{{ attr.type?.type }}</span>
                    </div>
                    <span class="specification-value">{{ attr.value?.label }}</span>
                  </div>
                </div>
              </div>

              <!-- Product Specifications -->
              <div class="product-specifications-section" *ngIf="data.data.product?.productSpecification && (data.data.product?.productSpecification?.length || 0) > 0">
                <h3 class="section-title">{{ 'ProductSpecifications' | translate }}</h3>
                <div class="specifications-list">
                  <div class="specification-item" *ngFor="let spec of data.data.product?.productSpecification || []">
                    <div class="specification-header">
                      <i class="fa fa-check-circle spec-check-icon"></i>
                      <span class="specification-title">{{ spec.title }}</span>
                    </div>
                    <span class="specification-value">{{ spec.value }}</span>
                  </div>
                </div>
              </div>

              <!-- Customer Information -->
              <div class="customer-section">
                <h3 class="section-title">{{ 'CustomerInformation' | translate }}</h3>
                <div class="customer-info">
                  <div class="customer-avatar">
                    <img [src]="data.data.user?.image || 'assets/images/user-placeholder.png'" 
                         [alt]="data.data.user?.name">
                  </div>
                  <div class="customer-details">
                    <p class="customer-name">{{ data.data.user?.name }}</p>
                    <p class="customer-email">{{ data.data.user?.email }}</p>
                    <p class="customer-phone">{{ data.data.user?.dialCode }} {{ data.data.user?.phoneNo }}</p>
                  </div>
                </div>
              </div>

              <!-- Notes Section -->
              <div class="notes-section" *ngIf="data.data.notes || data.data.rejectionReason">
                <div class="note-item" *ngIf="data.data.notes">
                  <i class="fa fa-sticky-note note-icon"></i>
                  <div>
                    <span class="note-label">{{ 'deliveryNotes' | translate }}:</span>
                    <p class="note-text">{{ data.data.notes }}</p>
                  </div>
                </div>
                <div class="note-item rejection" *ngIf="data.data.rejectionReason">
                  <i class="fa fa-exclamation-circle note-icon"></i>
                  <div>
                    <span class="note-label">{{ 'rejectionReason' | translate }}:</span>
                    <p class="note-text">{{ data.data.rejectionReason }}</p>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <!-- Description & Features Tab -->
          <mat-tab [label]="'DescriptionFeatures' | translate">
            <div class="tab-content">
              <mat-tab-group class="nested-tabs" animationDuration="300ms">
                <!-- Description Sub-tab -->
                <mat-tab [label]="'Description' | translate">
                  <div class="nested-tab-content">
                    <div class="product-description-section" *ngIf="data.data.product?.description || data.data.product?.description_ar">
                      <div class="description-content">
                        <div *ngIf="data.data.product?.description" [innerHTML]="data.data.product.description"></div>
                        <div *ngIf="data.data.product?.description_ar" class="arabic-text" [innerHTML]="data.data.product.description_ar"></div>
                      </div>
                    </div>
                    <div *ngIf="!data.data.product?.description && !data.data.product?.description_ar" class="no-content-message">
                      <p>{{ 'NoDescriptionAvailable' | translate }}</p>
                    </div>
                  </div>
                </mat-tab>

                <!-- Features Sub-tab -->
                <mat-tab [label]="'Features' | translate">
                  <div class="nested-tab-content">
                    <div class="product-features-section" *ngIf="data.data.product?.feature || data.data.product?.feature_ar">
                      <div class="features-content">
                        <div *ngIf="data.data.product?.feature" [innerHTML]="data.data.product.feature"></div>
                        <div *ngIf="data.data.product?.feature_ar" class="arabic-text" [innerHTML]="data.data.product.feature_ar"></div>
                      </div>
                    </div>
                    <div *ngIf="!data.data.product?.feature && !data.data.product?.feature_ar" class="no-content-message">
                      <p>{{ 'NoFeaturesAvailable' | translate }}</p>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </mat-tab>

          <!-- Pricing Tab -->
          <mat-tab [label]="'PricingDetails' | translate">
            <div class="tab-content">
              <div class="pricing-section">
                <div class="pricing-row">
                  <span class="pricing-label">{{ 'BasePriceOfProduct' | translate }}</span>
                  <span class="pricing-value">{{ (data.data.basePriceOfProduct || 0) | customCurrency }}</span>
                </div>
                <div class="pricing-row">
                  <span class="pricing-label">{{ 'DeliveryFee' | translate }}</span>
                  <span class="pricing-value">{{ (data.data.deliveryFee || 0) | customCurrency }}</span>
                </div>
                <div class="pricing-row" *ngIf="data.data.discount">
                  <span class="pricing-label">{{ 'Discount' | translate }}</span>
                  <span class="pricing-value discount-value">{{ (data.data.discount || 0) | customCurrency }}</span>
                </div>
                <div class="pricing-divider"></div>
                <div class="pricing-row total">
                  <span class="pricing-label">{{ 'SubTotal' | translate }}</span>
                  <span class="pricing-value">{{ (data.data.subTotal+(data.data.deliveryFee || 0) || 0) | customCurrency }}</span>
                </div>

                <!-- Commission Details -->
                <!-- <div class="commission-section" *ngIf="data.data.driverCommission || data.data.adminCommission || data.data.vendorCommission">
                  <h4 class="commission-title">{{ 'CommissionBreakdown' | translate }}</h4>
                  <div class="pricing-row" *ngIf="data.data.driverCommission">
                    <span class="pricing-label">{{ 'DriverCommission' | translate }}</span>
                    <span class="pricing-value commission">{{ (data.data.driverCommission || 0) | customCurrency }}</span>
                  </div>
                  <div class="pricing-row" *ngIf="data.data.adminCommission">
                    <span class="pricing-label">{{ 'AdminCommission' | translate }}</span>
                    <span class="pricing-value commission">{{ (data.data.adminCommission || 0) | customCurrency }}</span>
                  </div>
                  <div class="pricing-row" *ngIf="data.data.vendorCommission">
                    <span class="pricing-label">{{ 'VendorCommission' | translate }}</span>
                    <span class="pricing-value commission">{{ (data.data.vendorCommission || 0) | customCurrency }}</span>
                  </div>
                </div> -->
              </div>
            </div>
          </mat-tab>

          <!-- Delivery Information Tab -->
          <mat-tab [label]="'DeliveryInformation' | translate">
            <div class="tab-content">
              <!-- Shipment Addresses -->
              <div class="shipment-section">
                <div class="shipment-item">
                  <div class="shipment-header">
                    <i class="fa fa-warehouse"></i>
                    <h4>{{ 'From' | translate }}</h4>
                  </div>
                  <p class="shipment-address">{{ data.data.factory?.address || "---" }}</p>
                </div>
                <div class="shipment-arrow">
                  <i class="fa fa-arrow-down"></i>
                </div>
                <div class="shipment-item">
                  <div class="shipment-header">
                    <i class="fa fa-map-marker-alt"></i>
                    <h4>{{ 'To' | translate }}</h4>
                  </div>
                  <p class="shipment-address">{{ data.data.deliveryAddress?.address }}</p>
                </div>
              </div>

              <!-- Delivery Address Details -->
              <div class="address-details-section">
                <h3 class="section-title">{{ 'DeliveryAddressDetails' | translate }}</h3>
                
                <div class="address-grid">
                  <div class="address-item">
                    <i class="fa fa-user address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'Name' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.name }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-phone address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'Phone' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.countryCode }} {{ data.data.deliveryAddress?.phoneNo }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-envelope address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'Email' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.email || '---' }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-home address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'AddressType' | translate }}</span>
                      <span class="address-value">{{ getAddressType() }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-city address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'City' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.city || '---' }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-map address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'State' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.state || '---' }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-flag address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'Country' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.country || '---' }}</span>
                    </div>
                  </div>

                  <div class="address-item">
                    <i class="fa fa-mail-bulk address-icon"></i>
                    <div>
                      <span class="address-label">{{ 'Pincode' | translate }}</span>
                      <span class="address-value">{{ data.data.deliveryAddress?.pincode || '---' }}</span>
                    </div>
                  </div>
                </div>

                <!-- Map Button -->
                <button class="map-button" (click)="openGoogleMaps()">
                  <i class="fa fa-map-marked-alt"></i>
                  {{ 'ViewOnMap' | translate }}
                </button>
              </div>

              <!-- Driver Information -->
              <div class="driver-section" *ngIf="data?.data?.assignedDriver">
                <h3 class="section-title">{{ 'AssignedDriver' | translate }}</h3>
                <div class="driver-info">
                  <i class="fa fa-id-card driver-icon"></i>
                  <span class="driver-name">{{ data.data.assignedDriver?.driverId?.name }}</span>
                </div>
              </div>

              <!-- Factory Information -->
              <div class="factory-section" *ngIf="data?.data?.factory">
                <h3 class="section-title">{{ 'FactoryDetails' | translate }}</h3>
                <div class="factory-card">
                  <div class="factory-header">
                    <div class="factory-image-container" *ngIf="data?.data?.factory?.image">
                      <img [src]="data?.data?.factory?.image" [alt]="data?.data?.factory?.factoryName" class="factory-image">
                    </div>
                    <div class="factory-title-info">
                      <h4 class="factory-name">{{ data?.data?.factory?.factoryName }}</h4>
                      <p class="factory-owner" *ngIf="data?.data?.factory?.name">{{ data?.data?.factory?.name }}</p>
                    </div>
                  </div>
                  
                  <div class="factory-details-grid">
                    <div class="factory-detail-item">
                      <i class="fa fa-envelope factory-icon"></i>
                      <div>
                        <span class="factory-label">{{ 'Email' | translate }}</span>
                        <span class="factory-value">{{ data?.data?.factory?.email }}</span>
                      </div>
                    </div>

                    <div class="factory-detail-item">
                      <i class="fa fa-phone factory-icon"></i>
                      <div>
                        <span class="factory-label">{{ 'Phone' | translate }}</span>
                        <span class="factory-value">{{ data?.data?.factory?.dialCode }} {{ data?.data?.factory?.phoneNo }}</span>
                      </div>
                    </div>

                    <div class="factory-detail-item full-width">
                      <i class="fa fa-map-marker-alt factory-icon"></i>
                      <div>
                        <span class="factory-label">{{ 'Address' | translate }}</span>
                        <span class="factory-value">{{ data?.data?.factory?.address }}</span>
                      </div>
                    </div>

                    <div class="factory-detail-item" *ngIf="data?.data?.factory?.bio">
                      <i class="fa fa-info-circle factory-icon"></i>
                      <div>
                        <span class="factory-label">{{ 'Bio' | translate }}</span>
                        <span class="factory-value">{{ data?.data?.factory?.bio }}</span>
                      </div>
                    </div>

                    <div class="factory-detail-item" *ngIf="data?.data?.factory?.openingTime && data?.data?.factory?.closingTime">
                      <i class="fa fa-clock factory-icon"></i>
                      <div>
                        <span class="factory-label">{{ 'OperatingHours' | translate }}</span>
                        <span class="factory-value">
                          {{ data?.data?.factory?.openingTime | date: 'shortTime' }} - {{ data?.data?.factory?.closingTime | date: 'shortTime' }}
                        </span>
                      </div>
                    </div>

                    <div class="factory-detail-item" *ngIf="data?.data?.factory?.latitude && data?.data?.factory?.longitude">
                      <i class="fa fa-map-marked-alt factory-icon"></i>
                      <div>
                        <span class="factory-label">{{ 'Location' | translate }}</span>
                        <button class="factory-map-btn" (click)="openFactoryMap()">
                          <i class="fa fa-external-link-alt"></i>
                          {{ 'ViewOnMap' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <!-- Order Status History Tab -->
          <mat-tab [label]="'StatusHistory' | translate">
            <div class="tab-content">
              <div class="timeline" *ngIf="statusHistory.length > 0">
                <div class="timeline-item" *ngFor="let item of statusHistory" 
                     [ngClass]="{
                       'completed': item.isCompleted,
                       'upcoming': item.isUpcoming,
                       'current': item.isCurrent,
                       'rejected': item.isRejected
                     }">
                  <div class="timeline-dot"></div> 
                  <div class="timeline-content">
                    <div class="status-name">{{ item.statusName | translate }}</div>
                    <div class="status-time" *ngIf="item.isCompleted || item.isCurrent">{{ item.createdAt | date:'medium' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
